'use client';

import type { IconProps } from '@chakra-ui/react';
import { Icon as ChakraIcon } from '@chakra-ui/react';
import { FaGithub } from 'react-icons/fa6';
import { GiTurtle } from 'react-icons/gi';
import {
  MdCheck,
  MdChecklist,
  MdChevronRight,
  MdCircle,
  MdClose,
  MdCloseFullscreen,
  MdExpandLess,
  MdExpandMore,
  MdFavoriteBorder,
  MdMoreHoriz,
  MdOpenInFull,
  MdOutlineBarChart,
  MdOutlineBook,
  MdOutlineCancel,
  MdOutlineChatBubbleOutline,
  MdOutlineCheckCircle,
  MdOutlineEdit,
  MdOutlineErrorOutline,
  MdOutlineFirstPage,
  MdOutlineFolder,
  MdOutlineFolderShared,
  MdOutlineHelpOutline,
  MdOutlineHistoryEdu,
  MdOutlineInfo,
  MdOutlineLastPage,
  MdOutlineLock,
  MdOutlineLogout,
  MdOutlineMenu,
  MdOutlineNavigateBefore,
  MdOutlineNavigateNext,
  MdOutlineNotifications,
  MdOutlineOpenInNew,
  MdOutlinePeople,
  MdOutlinePerson,
  MdOutlineQuestionAnswer,
  MdOutlineRemoveCircleOutline,
  MdOutlineSearch,
  MdOutlineSettings,
  MdQuestionMark,
  MdRemove,
  MdReplay,
} from 'react-icons/md';
import { TbClock, TbDeviceDesktopCode } from 'react-icons/tb';

const iconByName = {
  analytics: MdOutlineBarChart,
  check: MdCheck,
  checkList: MdChecklist,
  chevronRight: MdChevronRight,
  chevronDown: MdExpandMore,
  chevronUp: MdExpandLess,
  chat: MdOutlineChatBubbleOutline,
  circle: MdCircle,
  clock: TbClock,
  contact: MdOutlineQuestionAnswer,
  contentCollapse: MdCloseFullscreen,
  contentExpand: MdOpenInFull,
  correct: MdCheck,
  edit: MdOutlineEdit,
  favorite: MdFavoriteBorder,
  github: FaGithub,
  groups: MdOutlineFolderShared,
  info: MdOutlineInfo,
  manualScoring: MdOutlineEdit,
  members: MdOutlinePeople,
  menu: MdOutlineMenu,
  more: MdMoreHoriz,
  navigateFirst: MdOutlineFirstPage,
  navigateLast: MdOutlineLastPage,
  navigateNext: MdOutlineNavigateNext,
  navigatePrevious: MdOutlineNavigateBefore,
  none: MdRemove,
  notifications: MdOutlineNotifications,
  openInNew: MdOutlineOpenInNew,
  portfolio: MdOutlineHistoryEdu,
  private: MdOutlineLock,
  remove: MdClose,
  repository: MdOutlineBook,
  reset: MdReplay,
  search: MdOutlineSearch,
  settings: MdOutlineSettings,
  signOut: MdOutlineLogout,
  submissions: MdOutlineFolder,
  taskCompletedAndCorrect: MdOutlineCheckCircle,
  taskCompletedAndWrong: MdOutlineCancel,
  taskCompletedButUnscored: MdOutlineHelpOutline,
  taskNotStarted: MdOutlineRemoveCircleOutline,
  taskInProgress: MdOutlineErrorOutline,
  user: MdOutlinePerson,
  wrong: MdClose,
  coding: TbDeviceDesktopCode,
  turtle: GiTurtle,
  question: MdQuestionMark,
} as const;

type Props = {
  icon: keyof typeof iconByName;
} & IconProps;

export const Icon: React.FC<Props> = ({ icon, ...props }) => {
  return <ChakraIcon as={iconByName[icon]} boxSize="1.5em" verticalAlign="-0.375em" {...props} />;
};
